import { create } from 'zustand';

const useDialogStore = create((set) => ({
  isOpen: false,
  title: '',
  message: '',
  confirmText: 'Potwierdź',
  cancelText: 'Anuluj',
  variant: 'default', // default, danger, info
  onConfirm: () => {},
  onCancel: () => {},

  openDialog: ({ title, message, confirmText, cancelText, variant, onConfirm, onCancel }) => {
    set({
      isOpen: true,
      title,
      message,
      confirmText: confirmText || 'Potwierdź',
      cancelText: cancelText || 'Anuluj',
      variant: variant || 'default',
      onConfirm: onConfirm || (() => {}),
      onCancel: onCancel || (() => {}),
    });
  },
  closeDialog: () => {
    set({ isOpen: false });
  }
}));

export default useDialogStore;